<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-08-05 10:51:09
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-02-05 10:49:27
 * @FilePath: \mrc-base-server-view\src\views\admin_account_manage\detail\index.vue
-->
<template>
  <div>
    <mrc_ess_skeleton_loader :loading="$store.state.uuid ? skeletonloading : false">
      <mrc_ess_iconGroup :is_disabled="disabled"
                         :show_del="false"
                         :showEdit="hasBtn('edit-corporate-administrator')"
                         @handleReturn="handleReturn"
                         @handleEdit="handleEdit"></mrc_ess_iconGroup>
      <base-info @success="success"
                 :disabled="disabled"
                 ref="baseInfo"
                 :loading="submitLoading"
                 :successText="params.staffs_uuid ? $t('解绑') : ''"
                 :paramsData="params"
                 @cancel="cancel"></base-info>
    </mrc_ess_skeleton_loader>
  </div>
</template>

<script>
import baseInfo from "../modules/baseInfo"
import {
  admin_account_info,
  admin_account_update,
  admin_account_del,
} from "@/service/api/admin_account_manage"
export default {
  components: { baseInfo },
  props: {},
  data () {
    return {
      disabled: true,
      params: {},
      skeletonloading: true,
      submitLoading: false,
      unbind_staff_uuid: "",
    }
  },
  validations: {},
  computed: {},
  created () { },
  watch: {
    disabled: {
      handler (v) {
        if (!v) {
          this.$route.meta.title = 'label_edit_enterprise_administrator'
          this.$store.commit('set_page_title', 'label_edit_enterprise_administrator')
        }
        else {
          this.$route.meta.title = 'label_view_enterprise_administrator'
          this.$store.commit('set_page_title', 'label_view_enterprise_administrator')
        }
      }, immediate: true
    }
  },
  async mounted () {
    this.$nextTick(async () => {
      if (!this.$store.state.iconstatus) {
        this.disabled = false
      }
      this.skeletonloading = true
      await this.national("mrbase_sys_users")
      const uuid = this.$route.params.uuid || this.$store.state.uuid
      const name = this.$store.getters.subPage_name
      this.$route.meta.name = name
      this.params.uuid = uuid
      await this.getInfo()
      this.skeletonloading = false
    })
  },

  methods: {
    handleReturn () {
      this.$router.go(-1)
    },
    handleEdit () {
      this.disabled = !this.disabled
    },
    async cancel () {
      this.getInfo()
      this.disabled = !this.disabled
      // this.$myConfirm({
      //   content: this.$t('message_Confirm_the_cancellation_of_the_edit'),
      // })
      //   .then(async () => {
      //     this.disabled = !this.disabled
      //     await this.getInfo()
      //   })
      //   .catch(() => {})
    },
    async success (val) {
      let obj = {}
      if (val.staffs_uuid) {
        obj = Object.assign(
          {},
          // { org_level_uuid: this.$store.state.userData.org_level_uuid },
          val
        )
      } else {
        obj = Object.assign({}, val, {
          unbind_staff_uuid: this.unbind_staff_uuid,
          // org_level_uuid: this.$store.state.userData.org_level_uuid
        })
      }
      this.submitLoading = true
      // console.log(obj);
      delete obj.user_pwd
      try {
        if (obj.staffs_uuid) {
          const res = await admin_account_del(obj)
          if (res.code == 200) {
            this.$Message({
              text: this.$t("message_The_operation_was_successful"),
            })
            this.$router.go(-1)
          }
        } else {
          const res = await admin_account_update(obj)
          if (res.code == 200) {
            this.$Message({
              text: this.$t("message_The_operation_was_successful"),
            })
            this.disabled = !this.disabled
          }
        }
        this.submitLoading = false
      } catch (err) {
        this.submitLoading = false
      }
    },
    async getInfo () {
      const res = await admin_account_info({
        uuid: this.params.uuid,
      })
      if (res.code == 200) {
        this.unbind_staff_uuid = res.data.staffs_uuid
        const {
          status,
          user_account,
          user_pwd,
          user_primary_email,
          clients_uuid,
          user_name,
          staffs_uuid,
          uuid,
          org_level_uuid,
          manager_type,
        } = res.data
        this.params = Object.assign(
          {},
          {
            status,
            user_account,
            user_pwd,
            user_primary_email,
            clients_uuid,
            user_name,
            staffs_uuid,
            uuid,
            confirmPassword: "",
            org_level_uuid,
            manager_type,
          }
        )
      }
    },
  },
}
</script>

<style scoped></style>
